import { useLazyQuery, useMutation } from "@apollo/client";
import gql from "graphql-tag";
import { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Button from "../../Button/Button";
import PortalFooter from "../../Reactportal/PortalFooter";
import Reactportal from "../../Reactportal/Reactportal";
import { ErrorToast, SuccessToast } from "../../ToastComponent/RectHotToast";
import useKeyDown from "../AddLoad/text";
import "./AddConnectionMemoUpdation.scss";
import { ConnectionMemoInputFields } from "./ConnectionMemoConfig";
import { LoadTable } from "../..";
import AddConnectionModal from "./AddConnectionModal";
import ConnectionMemoUpdationInputs from "./ConnectionMemoUpdationInputs";

const GET_LR = gql`
  query getConnectionMemoByIdWithLR($id: ID!) {
    getConnectionMemoByIdWithLR(id: $id) {
      _id
      LoadReceiptsData {
        LR_No
        _id
        LoadReceiptId
        Total_Number_Of_Boxes
      }
    }
  }
`;

const EDIT_CONNECTION_MEMO_UPDATION = gql`
  mutation editConnectionMemoUpdate($id: ID!, $input: ConnectionMemoUpdateSchemaInput!) {
    editConnectionMemoUpdate(id: $id, input: $input) {
      success
      ConnectionMemoData {
        _id
      }
    }
  }
`;

const AddConnectionMemoUpdation = ({ show, TypeOfPortal, fielddata, submitType }) => {
  const [openModal, setOpenModal] = useState(show ? show : false);
  const [addTableFieldsData, setAddTableFieldsData] = useState([{}]);
  const [open, setOpen] = useState(false);
  const [tableFields, setTableFields] = useState<any>([]);
  const FormData = useSelector((store: any) => store.FormFieldData);
  const [memoId, setMemoId] = useState("");
  const [connectionNumber, setConnectionNumber] = useState("");
  const [connectionUpdationData, setConnectionUpdationData] = useState<any>([]);
  const dispatch = useDispatch();

  const Closeformfunction1 = () => {
    setOpenModal(false);
    setAddTableFieldsData([{}]);
    setTableFields([]);
  };
  const [EditConnectionMemoUpdation, { loading, error, data }] = useMutation(EDIT_CONNECTION_MEMO_UPDATION);
  const [GetLRData, { loading: getLoading }] = useLazyQuery(GET_LR);
  const LoadingState = getLoading ? true : false;
  useEffect(() => {
    if (show === true) {
      setOpenModal(true);
    }
  }, [show]);

  const submit = async () => {
    let allValuesAreNonNegative = tableFields.every((obj) => obj.Balance >= 0);

    if (!allValuesAreNonNegative) {
      ErrorToast("Wrong Connection Entry");
      return;
    }
    const idArray = connectionUpdationData.map((item: any) => item.LoadReceiptID);
    let data: any = {
      Data: connectionUpdationData,
      Date: FormData.fielddata.Connection_Memo_Updation.Date,
      Memo_No: FormData.fielddata.Connection_Memo_Updation.Memo_Number,
      LoadReceiptsIds: idArray,
    };

    if (TypeOfPortal === "Edit Pickup Memo") {
      // const res = await editBranch({
      //   variables: { id: allFieldsData.id, userInput: data },
      // })
      //   .then((res) => {
      //     dispatch({ type: "Refetch", payload: true });
      //     SuccessToast("Pickup Memo Edited Successfully");
      //   })
      //   .catch((err) => {
      //     ErrorToast(err.message);
      //   });
    } else if (TypeOfPortal === "Delete Pickup Memo") {
      // const ArrayOfID = selectedRows.map((obj: any) => obj.id);
      // await deleteBranch({
      //   variables: { idsToDelete: ArrayOfID },
      // })
      //   .then((res) => {
      //     dispatch({ type: "Refetch", payload: true });
      //     SuccessToast("Pickup Memo Deleted");
      //     settoggle(false);
      //   })
      //   .catch((err) => {
      //     ErrorToast(err.message);
      //   });
    } else {
      await EditConnectionMemoUpdation({
        variables: {
          id: memoId,
          input: data,
        },
      })
        .then((res) => {
          dispatch({ type: "Refetch", payload: true });
          SuccessToast("Connection Memo Updated Successfully");
        })
        .catch((err) => {
          ErrorToast(err.message);
        });
    }
    if (error) {
      ErrorToast(error.message);
    }
  };

  const handleDemoFunction = () => {
    if (FormData.masterData.Memo_Number) {
      GetLRData({
        variables: {
          id: FormData.masterData.Memo_Number._id,
        },
      })
        .then((res) => {
          setMemoId(res.data.getConnectionMemoByIdWithLR[0]._id);
          let temp = res.data.getConnectionMemoByIdWithLR[0].LoadReceiptsData;
          let arr: any = [];
          let arr1: any = [];
          for (let i = 0; i < temp.length; i++) {
            let obj: any = {};
            let obj1: any = {};
            obj.LR_No = temp[i].LR_No;
            obj.No_Of_Boxes = temp[i].Total_Number_Of_Boxes;
            obj.Connection_1 = 0;
            obj.Connection_2 = 0;
            obj.Connection_3 = 0;
            obj.Balance = 0;
            obj1.LoadReceiptID = temp[i]._id;
            obj1.No_Of_Boxes = String(temp[i].Total_Number_Of_Boxes);
            obj1.Connection_1 = 0;
            obj1.Connection_2 = 0;
            obj1.Connection_3 = 0;
            obj1.Balance = 0;
            arr.push(obj);
            arr1.push(obj1);
          }
          setTableFields(arr);
          setConnectionUpdationData(arr1);
        })
        .catch((err) => console.log(err));
    }
  };

  const handleUpdateConnection = (data) => {
    const arr = data.map((item, index) => ({
      LR_No: item.LR_No,
      No_Of_Boxes: item.No_Of_Boxes,
      Connection_1: item.Connection_1,
      Connection_2: item.Connection_2,
      Connection_3: item.Connection_3,
      Balance: item.No_Of_Boxes - (item.Connection_1 + item.Connection_2 + item.Connection_3),
    }));
    let updateArray = connectionUpdationData.map((obj, i) => {
      return {
        ...obj,
        Connection_1: data[i].Connection_1,
        Connection_2: data[i].Connection_2,
        Connection_3: data[i].Connection_3,
        Balance: (obj.No_Of_Boxes - (data[i].Connection_1 + data[i].Connection_2 + data[i].Connection_3)).toString(),
      };
    });
    setTableFields(arr);
    setConnectionUpdationData(updateArray);
  };
  const handleAddClick = (num) => {
    setOpen(true);
    setConnectionNumber(num);
  };

  const HandleKeyDownf3 = useCallback(
    (event) => {
      if (event.ctrlKey && event.shiftKey && event.key === "S") {
        submit();
      } else if (event.keyCode === 27) {
        event.preventDefault();
        return Closeformfunction1();
      }
    },
    [Closeformfunction1]
  );
  useKeyDown(HandleKeyDownf3);
  return (
    <>
      {openModal ? (
        <div>
          <Reactportal open={openModal} onClose={Closeformfunction1} TypeOfPortal={TypeOfPortal}>
          {LoadingState && <div className="loader-line-div"/>}
            <div className="MemoUpdation">
              <div>
                {ConnectionMemoInputFields.map((e, i) => {
                  return (
                    <div key={e.id} style={{ margin: "10px" }}>
                      <ConnectionMemoUpdationInputs
                        inputfields={e.fields}
                        Type={e.name}
                        formkey={""}
                        fielddata={fielddata}
                        TypeOfPortal={TypeOfPortal}
                        handleDemoFunction={() => handleDemoFunction()}
                      />
                    </div>
                  );
                })}
              </div>

              <div className="inputTable">
                {tableFields && tableFields.length > 0 && (
                  <LoadTable data={tableFields} loading={false} error={null} title={"Connection Memo Updation"} />
                )}
              </div>
              {tableFields && tableFields.length > 0 && (
                <div className="addConnectionBtn">
                  <Button
                    name="modalbutton"
                    text="Add Connection 1"
                    action={() => handleAddClick("1")}
                    type={""}
                    children={""}
                    disabled={""}
                  ></Button>
                  <Button
                    name="modalbutton"
                    text="Add Connection 2"
                    action={() => handleAddClick("2")}
                    type={""}
                    children={""}
                    disabled={""}
                  ></Button>
                  <Button
                    name="modalbutton"
                    text="Add Connection 3"
                    action={() => handleAddClick("3")}
                    type={""}
                    children={""}
                    disabled={""}
                  ></Button>
                </div>
              )}
            </div>
            {open && (
              <AddConnectionModal
                show={open}
                TypeOfPortal={TypeOfPortal}
                setOpen={() => setOpen(false)}
                fielddata={{}}
                handleUpdateConnection={(val) => handleUpdateConnection(val)}
                LRData={tableFields}
                connectionNumber={connectionNumber}
              />
            )}

            <PortalFooter
              renderContent={() => <></>}
              disabled={false}
              submitform={submit}
              submitType={submitType}
              loadingState={LoadingState }
              SaveAndClose={() => {
                Closeformfunction1();
                submit();
              }}
              handleformclose={() => {
                Closeformfunction1();
                setOpenModal(!openModal);
              }}
            />
          </Reactportal>
        </div>
      ) : (
        <div></div>
      )}
    </>
  );
};

export default AddConnectionMemoUpdation;
